import slugify from 'slugify';
import { ProductCard, ProductComponents } from 'ui/components';
import { ComboButton } from '../ComboButton';
import { TCardData } from '../ProductList/ProductList';
import { isMobile } from 'core/use-cases/app/helpers';
import { formatMoney } from 'core/utilities';
import { ProductListCardStyles } from './ProductListCard.styles';
import ProductListInfo from './ProductListInfo';
import { getValueTag } from 'ui/containers/ContentBuilder/widgets/utilities/tag';

const ProductListCard = ({
  addItem,
  updateItem,
  isBuyIntentionFeatureActive,
  isBuyIntention,
  setBuyIntention,
  cardData: {
    image,
    name,
    productCode,
    quantity = 0,
    tags,
    productPosition,
    productOrigin,
    isCustomCombo,
    isAvailable,
    hasSimilar,
    priceWrapper,
    resellerOnly,
    itemListName,
    slugName,
  },
  isResaleIntention,
  isAutoStartEnabled,
}: TCardData) => {
  const isAvailableCard = isCustomCombo ? true : isAvailable;
  const isMobileFlag = isMobile();

  const discountPercentage = priceWrapper?.resellerPrice?.discountPercentage ?? 0;
  const formatResellerPrice = {
    price: formatMoney(priceWrapper?.resellerPrice?.price ?? 0),
    profit: formatMoney(priceWrapper?.resellerPrice?.profit ?? 0),
    maxPrice: formatMoney(priceWrapper?.resellerPrice?.maxPrice ?? 0),
    discountPercentage,
  };

  const formatConsumerPrice = {
    price: formatMoney(priceWrapper?.consumerPrice?.price ?? 0),
    maxPrice: formatMoney(priceWrapper?.consumerPrice?.maxPrice ?? 0),
    percent: priceWrapper?.consumerPrice?.percent,
  };
  const discount = getValueTag(formatResellerPrice, formatConsumerPrice);
  const slugNameStr = slugName ?? slugify(name);

  return (
    <ProductCard.Card
      data-available={isAvailableCard}
      data-radius="rounded"
      data-testid="product-card"
      data-link={true}
      spacing={isMobileFlag ? 'small' : 'medium'}
    >
      <ProductListCardStyles.LinkProductDetail to={`/produto/${slugNameStr}?sku=${productCode}`}>
        <ProductListInfo
          discount={discount}
          name={name}
          isAvailableCard={isAvailableCard}
          image={image}
          productCode={productCode}
          tags={tags}
          formatConsumerPrice={formatConsumerPrice}
          formatResellerPrice={formatResellerPrice}
          isResellerOnly={resellerOnly}
        />
      </ProductListCardStyles.LinkProductDetail>

      {isCustomCombo && isAvailableCard && <ComboButton name={name} productCode={productCode} />}
      {!isCustomCombo && isAvailableCard && (
        <ProductComponents.AvailableButton
          itemListName={itemListName}
          onAddProduct={addItem}
          onChangeAmount={updateItem}
          productCode={productCode}
          productPosition={productPosition}
          productOrigin={productOrigin}
          quantity={quantity}
          disabled={isResaleIntention && !isAutoStartEnabled}
          name={name}
        />
      )}
      {!isAvailableCard && (
        <ProductComponents.UnavailableButton
          isBuyIntention={isBuyIntention(productCode)}
          isBuyIntentionFeatureActive={isBuyIntentionFeatureActive && !isCustomCombo}
          name={name}
          productCode={productCode}
          setBuyIntention={setBuyIntention}
          isResaleIntention={isResaleIntention}
          isAutoStartEnabled={isAutoStartEnabled}
          hasSimilar={hasSimilar}
          slugName={slugNameStr}
        />
      )}
    </ProductCard.Card>
  );
};

export default ProductListCard;
